module.exports = __webpack_public_path__ + "static/media/check-selected.33ba4f0b.svg";